import React from 'react';

import WebsiteAdminFetchingSettingNumericFieldRow, {
	WebsiteAdminFetchingSettingNumericFieldRowUnit,
} from '~/components/app/WebsiteAdminFetchingSettingNumericFieldRow';



type Props = {
	name: string,
};

const WebsiteAdminFetchingSettingMainRequestSizeLimitFieldRow: React.FC<Props> = (props) => {
	const {
		name,
	} = props;

	return (
		<WebsiteAdminFetchingSettingNumericFieldRow
			autoValue={1048576}
			label="Size limit"
			name={name}
			unit={WebsiteAdminFetchingSettingNumericFieldRowUnit.Byte}
		/>
	);
};



export default WebsiteAdminFetchingSettingMainRequestSizeLimitFieldRow;
